module.exports = __webpack_public_path__ + "img/pickup_stopped.798fcf0d.svg";